import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import AppointmentRevisitAppointmentAudit from './audit'

const AppointmentRevisitAppointmentDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [appointmentDetail, setAppointmentDetail] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isAuditVisible, setIsAuditVisible] = useState(false)

  const getAppointmentDetail = () => {
    axios.post('/p/alumni/revisit_appointment/detail/get', {
      merchant_oid: merchantOid,
      appointment_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAppointmentDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAppointmentDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const getColor = () => {
    if (appointmentDetail.status.key === 2) return 'green'
    if (appointmentDetail.status.key === 3) return 'red'
    return 'black'
  }

  const openAudit = () => {
    setIsAuditVisible(true)
    setPropsData({ 
      oid: appointmentDetail.oid,
      status: appointmentDetail.status.key,
      failureReason: appointmentDetail.failure_reason
    })
  }

  return (
    <Modal 
      title="详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>申请时间</div>
          <div className='public-datail-content'>{appointmentDetail.create_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>姓名</div>
          <div className='public-datail-content'>{appointmentDetail.name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>手机号</div>
          <div className='public-datail-content'>{appointmentDetail.phone}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>返校是由</div>
          <div className='public-datail-content'>{appointmentDetail.reason}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>拜访部门</div>
          <div className='public-datail-content'>{appointmentDetail.department}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>返校时间</div>
          <div className='public-datail-content'>{appointmentDetail.return_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>离校时间</div>
          <div className='public-datail-content'>{appointmentDetail.leave_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>同行人数</div>
          <div className='public-datail-content'>{appointmentDetail.companions}</div>
        </div>

        {appointmentDetail.status && 
          <div className='public-datail-item'>
            <div className='public-datail-label'>审核状态</div>
            <div style={{ color: getColor() }} className='public-datail-status'>{appointmentDetail.status.value}</div>
            <div className='public-datail-button' onClick={openAudit}>审核</div>
          </div>
        }
        {(appointmentDetail.status && appointmentDetail.status.key === 3) &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>拒绝原因</div>
            <div className='public-datail-content'>{appointmentDetail.failure_reason || '未填写'}</div>
          </div>
        }
      </div>

      {isAuditVisible && <AppointmentRevisitAppointmentAudit
        data={propsData}
        getAppointmentDetail={getAppointmentDetail}
        getAppointmentData={() => { props.getAppointmentData() }}
        isOpen={isAuditVisible}
        isCancel={() => { setIsAuditVisible(false) }}
      />}
    </Modal>
  )
}

export default AppointmentRevisitAppointmentDetail
